<template>
  <!-- navbar -->
  <nav class="navbar navbar-default navbar-fixed-top">
    <div class="container">
      <!-- Brand and toggle get grouped for better mobile display -->
      <div class="navbar-header">
        <button
          type="button"
          class="navbar-toggle collapsed"
          data-toggle="collapse"
          data-target="#navbar__collapse"
          aria-expanded="false"
        >
          <span class="sr-only">Menu</span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
        </button>
        <router-link to="/" class="navbar-brand">Restaurant Dafni</router-link>
      </div>

      <!-- Collect the nav links, forms, and other content for toggling -->
      <div class="collapse navbar-collapse" id="navbar__collapse">
        <ul class="nav navbar-nav navbar-right">
          <!-- General links -->
          <li><router-link to="/">Home</router-link></li>
          <li><router-link to="/mittagskarte">Mittagskarte</router-link></li>
          <li><router-link to="/speisekarte">Speisekarte</router-link></li>
          <li><router-link to="/ueberuns">Über uns</router-link></li>
          <li><router-link to="/galerie">Galerie</router-link></li>
          <li><router-link to="/kontakt">Kontakt</router-link></li>
        </ul>
      </div>
      <!-- /.navbar-collapse -->
    </div>
    <!-- /.container -->
  </nav>
</template>

<script>
export default {
  name: "Navbar",
  mounted() {}
};
</script>

<style lang="scss">
.navbar .nav {
  & .router-link-exact-active {
    color: #f1ae2b;
    background-color: transparent;

    &::before {
      content: "";
      position: absolute;
      top: 95%;
      left: 0;
      right: 0;
      height: 3px;
      background-color: #f1ae2b;
    }
  }
}
</style>
